import React from "react";

import styles from "./SmarterFasterHeader.css";

export default function SmarterFasterHeader() {
  return (
    <div className={styles.root}>
      <img
        src={require("assets/img/smarter-faster@3x.png")}
        alt="Smarter Faster: Presented by JP Morgan Chase & Co."
      />
      <p className={styles.text}>
        <i>
          Thank you to JPMorgan Chase & Co. for underwriting the Axios Smarter
          Faster series, featuring leaders explaining the ideas shaping their
          lives and worldviews. This series contains both underwritten videos,
          over which Axios retains full editorial control, and branded videos
          co-created by Axios on behalf of JPMorgan Chase & Co. Videos are
          labeled accordingly below.
        </i>
      </p>
    </div>
  );
}
